import React from 'react';
import { Plus, Trash2, Edit2, Users } from 'lucide-react';
import { useI18n } from '../i18n';
import { calcularIdade, getMemberHex } from '../utils';
import { Avatar, Button, Card, IconButton, Notice, PageHeader, EmptyState } from './ui';

const GENDER_KEYS = {
  homem: 'modal.genderMale',
  mulher: 'modal.genderFemale',
  nao_binario: 'modal.genderNonBinary',
};

export default function Membros({ membros, onNew, onEdit, onDelete }) {
  const { t } = useI18n();
  return (
    <div>
      <PageHeader
        title={t('members.title')}
        subtitle={t('members.description')}
        actions={<Button onClick={onNew}><Plus size={16} />{t('members.newMember')}</Button>}
      />
      <Notice className="mb-5">
        <span dangerouslySetInnerHTML={{ __html: t('members.invitesTip') }} />
      </Notice>
      {membros.length === 0 ? (
        <EmptyState icon={Users} title={t('dashboard.noMembers')} action={<Button onClick={onNew}><Plus size={16} />{t('members.newMember')}</Button>} />
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {membros.map(membro => {
            const idade = calcularIdade(membro.data_nascimento);
            const generoKey = GENDER_KEYS[membro.genero];
            const meta = [generoKey && t(generoKey), idade !== null && t('common.years', { count: idade })].filter(Boolean).join(' · ');
            return (
              <Card key={membro.id} className="p-4 flex items-start gap-3">
                <Avatar src={membro.avatar_url} name={membro.nome} color={getMemberHex(membro.id, membros)} size="lg" square />
                <div className="flex-1 min-w-0 pt-0.5">
                  <div className="font-semibold text-gray-900 truncate">{membro.nome}</div>
                  {meta && <div className="text-xs text-gray-500 mt-0.5">{meta}</div>}
                </div>
                <div className="flex items-center -mr-2 -mt-1">
                  <IconButton icon={Edit2} label={t('common.edit')} onClick={() => onEdit(membro)} />
                  <IconButton icon={Trash2} label={t('common.delete')} tone="danger" onClick={() => onDelete(membro)} />
                </div>
              </Card>
            );
          })}
        </div>
      )}
    </div>
  );
}
